import React, { useEffect, useContext } from 'react';
import { MapContainer, TileLayer, useMap, ZoomControl } from 'react-leaflet';

import { UserLocation } from './create-meeting-map-marker';
import { Markers } from './prefer-location-marker';
import Search from '../../../../components/Map/Search';

import { CreateMeetingContext } from '../../../../services/create-meeting/create-meeting.context';

const MapFitBound = ({ userLocation, location }) => {
  const map = useMap();
  useEffect(() => {
    let locationList = [];
    userLocation.map((item) =>
      item.lat && item.lng ? locationList.push([item.lat, item.lng]) : null
    );
    locationList.length > 0 &&
      map.fitBounds(locationList, { padding: [60, 75] });
  }, [map, userLocation]);
  return null;
};

export const CreateMeetingMap = () => {
  const { states } = useContext(CreateMeetingContext);
  const { location, usersInfo } = states;
  const position = {
    lat: '29.62316571303948',
    lng: '52.523923516273506',
  };

  return (
    <MapContainer
      center={location && location.lat && location.lng ? location : position}
      zoom={15}
      zoomControl={false}
      minZoom={1}
      boundsOptions={{ padding: [12, 36] }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      />

      <ZoomControl position='topright' />

      {usersInfo &&
        usersInfo.map(
          (user) =>
            user.lat &&
            user.lng && <UserLocation userLocation={user} key={user.uid} />
        )}
      <Markers />
      <Search />
      {usersInfo && <MapFitBound userLocation={usersInfo} />}
    </MapContainer>
  );
};
